import type { Step } from "react-joyride";

export const categoriesTourSteps: Step[] = [
  {
    target: "body",
    content: "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການຫມວດມູ່. ຂໍແນະນຳການນຳໃຊ້ເບື້ອງຕົ້ນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="catalog-categories-filter"]',
    content:
      "ກອງຂໍ້ມູນ: ຄົ້ນຫາຫມວດມູ່ດ້ວຍຊື່ (ລາວ, ໄທ, ອັງກິດ) ຫຼື Slug. ກົດ 'ล้าง' ເພື່ອລຶບການກອງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="catalog-categories-table"]',
    content:
      "ຕາຕະລາງຫມວດມູ່ແບບລໍາດັບ: ສະແດງຫມວດມູ່ແມ່ ແລະ ຫມວດມູ່ຍ່ອຍຢ່າງຊັດເຈນ ພ້ອມໄອຄອນບອກລະດັບ.",
    placement: "top",
  },
  {
    target: '[data-tourid="catalog-categories-toolbar"]',
    content:
      "ປຸ່ມສ້າງຫມວດມູ່ໃໝ່: ກົດเพื่อເພີ່ມຫມວດມູ່ ແລະ ເລືອກຫມວດມູ່ແມ່ເພື່ອສ້າງລຳດັບ.",
    placement: "bottom",
  },
];
